import type * as React from 'react';

export default function useCombinedRef() {
  const combinedRef = <T>(
    refs: Array<React.MutableRefObject<T> | React.LegacyRef<T>>,
  ): React.RefCallback<T> => (value) => {
      refs.forEach((ref) => {
        if (typeof ref === 'function') {
          ref(value);
        } else if (ref != null) {
          (ref as React.MutableRefObject<T | null>).current = value;
        }
      });
    };

  return {
    combinedRef,
  };
}
